import { ButtonBase, MenuItem, styled } from '@mui/material';
import { BooleanChip } from './BooleanChip';
import React from 'react';
import { Menu, MenuButton } from '../Menu';

interface Props {
  value: boolean;
  onEdit: (value: boolean) => void;
  labelTrue: string;
  labelFalse: string;
}

export const BooleanOptionsMenu: React.FC<Props> = ({ value, onEdit, labelTrue, labelFalse }) => {
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={StyledMenuButton}>
            <BooleanChip value={value} label={value ? labelTrue : labelFalse} />
          </MenuButton>
          <MenuItem
            value={'true'}
            onClick={() => {
              onClose();
              onEdit(true);
            }}
          >
            <BooleanChip value label={labelTrue} />
          </MenuItem>
          <MenuItem
            value={'false'}
            onClick={() => {
              onClose();
              onEdit(false);
            }}
          >
            <BooleanChip value={false} label={labelFalse} />
          </MenuItem>
        </>
      )}
    </Menu>
  );
};

const StyledMenuButton = styled(ButtonBase)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create(['box-shadow'], {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover, &:focus-visible': {
    boxShadow: theme.shadows[6],
  },
}));
